export default "__VITE_ASSET__BQper9ir__"